import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { GetData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";

function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
  };
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);

  const Handler = data => {
    setstate({ ...state, loading: true });
    GetData(data).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست درخواست</title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <DataTable
            loading={state.loading}
            heads={[
              {
                title: "نام باشگاه",
                key: "form_details",
                keyName: "itemfullname",
              },
              {
                title: "نام مدیر باشگاه",
                key: "form_details",
                keyName: "itemadminname",
              },

              {
                title: "تاریخ درخواست",
                key: "created_at",
                type: "date",
                timetype: "date-time",
              },
            ]}
            textEmpty="درخواستی تا کنون ثبت نشده است"
            list={state.data && state.data.data}
            data={state.data}
            function={Handler}
            removeselectitem={true}
            currentPage={state?.data?.current_page}
            header="درخواست های قبلی"
            textbtn="درخواست جدید"
            linkbtn="/User/Createnewitem"
          />
        </div>
      </div>
    </Fragment>
  );
}

export default List;
